import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp, getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnLabel from "@shared/components/SnLabel";
import SnNumberBox from "@shared/components/SnNumberBox";
import SnResizeBar from "@shared/components/SnResizeBar";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_EBL_REG_001_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
      grid5: React.createRef(),
      grid6: React.createRef(),
    });

    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [renderTick, setRenderTick] = useState(0);

    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
      grid6: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
      grid6: [],
    });

    const [selectedTabPage, setTapPage] = useState<string>("1");
    const isSyncingCheckbox = useRef(false);

    const inputRefs = useRef<any>([]);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let isSame: boolean = false;

        let selectedHeader: any[] = [];
        switch (selectedTabPage) {
          case "1":
            selectedHeader =
              gridRefs.current["grid1"].current?.getCheckedRows();
            break;
          case "2":
            selectedHeader =
              gridRefs.current["grid3"].current?.getCheckedRows();
            break;
          case "3":
            selectedHeader =
              gridRefs.current["grid5"].current?.getCheckedRows();
            break;
        }

        if (selectedHeader && selectedHeader.length > 0) {
          const cdCustValue = selectedHeader[0].cd_cust; // 거래처

          isSame = selectedHeader.every(
            (item: any) => item.cd_cust === cdCustValue
          );
        } else {
          return { flag: true };
        }

        if (!isSame) {
          return {
            flag: false,
            message: "거래처가 동일한 건만 적용 가능합니다.",
          };
        } else {
          return { flag: true };
        }
      },
      getSelectedRow: () => {
        return selectedTabPage === "1"
          ? [
              gridRefs.current["grid1"].current?.getCheckedRows() || [],
              gridRefs.current["grid2"].current?.getCheckedRows() || [],
            ]
          : selectedTabPage === "2"
            ? [
                gridRefs.current["grid3"].current?.getCheckedRows() || [],
                gridRefs.current["grid4"].current?.getCheckedRows() || [],
              ]
            : [
                gridRefs.current["grid5"].current?.getCheckedRows() || [],
                gridRefs.current["grid6"].current?.getCheckedRows() || [],
              ];
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_TRA_EBL_REG_001_POP_002",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);

          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
            grid5: rtn.grid.grid5,
            grid6: rtn.grid.grid6,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_tra_ebl_reg_001_POP_002_01",
          params: searchRef.current.getFormdata(),
        };
        const data: any = await fnGetDataSet(param);

        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
          grid3: data[2] || [],
          grid4: data[3] || [],
          grid5: data[4] || [],
          grid6: data[5] || [],
        });

        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        gridRefs.current["grid3"].current.resetUpdate();
        gridRefs.current["grid4"].current.resetUpdate();
        gridRefs.current["grid5"].current.resetUpdate();
        gridRefs.current["grid6"].current.resetUpdate();
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    const onFocusedRowChanged1 = (row: any) => {
      const no_io = row?.no_io;
      gridRefs.current["grid2"].current.applyFilters({ no_io: no_io });
    };

    const onFocusedRowChanged3 = (row: any) => {
      const cd_cust = row?.cd_cust;
      const cd_exch = row?.cd_exch;
      const fg_trns = row?.fg_trns;
      const cd_fin = row?.cd_fin;
      gridRefs.current["grid4"].current.applyFilters({
        cd_cust: cd_cust,
        cd_exch: cd_exch,
        fg_trns: fg_trns,
        cd_fin: cd_fin,
      });
    };

    const onFocusedRowChanged5 = (row: any) => {
      const no_io = row?.no_io;
      gridRefs.current["grid6"].current.applyFilters({ no_req: no_io });
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);

      // Optional: reset filters on tab change
      if (index === "1") {
        gridRefs.current["grid1"].current?.selectAndFocusRow(0);
        gridRefs.current["grid2"].current?.selectAndFocusRow(0);
      } else if (index === "2") {
        gridRefs.current["grid3"].current?.selectAndFocusRow(0);
        gridRefs.current["grid4"].current?.selectAndFocusRow(0);
      } else if (index === "3") {
        gridRefs.current["grid5"].current?.selectAndFocusRow(0);
        gridRefs.current["grid6"].current?.selectAndFocusRow(0);
      }
    };

    const handleSelectionChange = (checkdRows: any) => {
      if (checkdRows.length === 0) {
        inputRefs.current[0].value = 0;
        inputRefs.current[1].value = 0;
        inputRefs.current[2].value = 0;
        inputRefs.current[3].value = 0;
        return;
      }

      const totalAmk = checkdRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_k : acc - row.am_k;
      }, 0);

      const totalAmvat = checkdRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_vat : acc - row.am_vat;
      }, 0);

      const totalAm = checkdRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1"
          ? Math.round((acc + row.am) * 100) / 100
          : Math.round((acc - row.am) * 100) / 100;
      }, 0);

      const totalQt = checkdRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.qt : acc - row.qt;
      }, 0);

      inputRefs.current[0].value = totalAmk;
      inputRefs.current[1].value = totalAmvat;
      inputRefs.current[2].value = totalAm;
      inputRefs.current[3].value = totalQt;
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }

      const checkdRows = gridRefs.current["grid2"].current.getCheckedRows();
      handleSelectionChange(checkdRows);
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );

      handleSelectionChange(checkdRows);
    };

    const onCheckedRowChaged3 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid4"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid4"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged4 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid4"].current.getCheckedFilteredRows();
      handleSelectionChange(checkdRows);
      if (checkdRows.length > 0)
        gridRefs.current["grid3"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid3"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const onCheckedRowChaged5 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid6"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid6"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged6 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid6"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        gridRefs.current["grid5"].current.setCheckedFocusedRow(true, "noEvent");
      } else
        gridRefs.current["grid5"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );

      handleSelectionChange(checkdRows);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged1,
            onCheckedRowChaged: onCheckedRowChaged1,
            //onRowDataReady,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onFocusedRowChanged: onFocusedRowChanged3,
            onCheckedRowChaged: onCheckedRowChaged3,
          },
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
          events: {
            onCheckedRowChaged: onCheckedRowChaged4,
          },
        },
        grid5: {
          columns: columns.grid5,
          dataSource: dataSources.grid5,
          events: {
            onFocusedRowChanged: onFocusedRowChanged5,
            onCheckedRowChaged: onCheckedRowChaged5,
          },
        },
        grid6: {
          columns: columns.grid6,
          dataSource: dataSources.grid6,
          events: {
            onCheckedRowChaged: onCheckedRowChaged6,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div className="mb-2">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div
          style={{
            display: "flex",
            width: "1125px",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <SnLabel text={"원화합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={0}
            format="#####"
            isRequired={true}
            isReadOnly={true}
            inputRef={(el: any) => (inputRefs.current[0] = el)}
          />
          <SnLabel text={"부가세합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={0}
            format="#####"
            isRequired={true}
            isReadOnly={true}
            inputRef={(el: any) => (inputRefs.current[1] = el)}
          />

          <SnLabel text={"총금액합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={0}
            format="#####"
            isRequired={true}
            isReadOnly={true}
            inputRef={(el: any) => (inputRefs.current[2] = el)}
          />

          <SnLabel text={"총수량합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={0}
            format="#####"
            isRequired={true}
            isReadOnly={true}
            inputRef={(el: any) => (inputRefs.current[3] = el)}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnTab
            titles={["출하번호별", "고객사별", "출하의뢰번호별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div className="space-y-1.5" style={{ height: "23vh" }}>
                <SnGrid
                  ref={gridRefs.current["grid1"]} // Grid Name
                  columnConfig={grids.grid1.columns} // 컬럼 설정 전달
                  rowData={grids.grid1.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid1.events}
                />

                <SnGrid
                  ref={gridRefs.current["grid2"]} // Grid Name
                  columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                  rowData={grids.grid2.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid2.events}
                />
              </div>,

              <div className="space-y-1.5" style={{ height: "23vh" }}>
                <SnGrid
                  ref={gridRefs.current["grid3"]} // Grid Name
                  columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                  rowData={grids.grid3.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid3.events}
                />
                <SnGrid
                  ref={gridRefs.current["grid4"]} // Grid Name
                  columnConfig={grids.grid4.columns} // 컬럼 설정 전달
                  rowData={grids.grid4.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid4.events}
                />
              </div>,

              <div className="space-y-1.5" style={{ height: "23vh" }}>
                <SnGrid
                  ref={gridRefs.current["grid5"]} // Grid Name
                  columnConfig={grids.grid5.columns} // 컬럼 설정 전달
                  rowData={grids.grid5.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid5.events}
                />
                <SnGrid
                  ref={gridRefs.current["grid6"]} // Grid Name
                  columnConfig={grids.grid6.columns} // 컬럼 설정 전달
                  rowData={grids.grid6.dataSource} // Datasource
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                  events={grids.grid6.events}
                />
              </div>,
            ]}
          />
        </div>
      </div>
    );
    //#endregion
  }
);

export default SN_TRA_EBL_REG_001_POP_002;
